import React from 'react';

interface LoadingSpinnerProps {
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = 'Loading...',
}) => {
  return (
    <div className="flex flex-col items-center justify-center h-screen gap-4">
      <div
        className="w-14 h-14 rounded-full border-8 border-gray-200
                   border-t-primary animate-spin"
      />
      <p className="text-gray-600 text-base">{message}</p>
    </div>
  );
};

export default LoadingSpinner;
